import i18n from '../i18n';

export default class MonthListType {
  public static readonly NONE = new MonthListType('', '1カ月以内');
  public static readonly MON202206 = new MonthListType('202206', '2022年6月');
  public static readonly MON202207 = new MonthListType('202207', '2022年7月');
  public static readonly MON202208 = new MonthListType('202208', '2022年8月');
  public static readonly MON202209 = new MonthListType('202209', '2022年9月');
  public static readonly MON202210 = new MonthListType('202210', '2022年10月');
  public static readonly MON202211 = new MonthListType('202211', '2022年11月');
  public static readonly MON202212 = new MonthListType('202212', '2022年12月');
  public static readonly INDSTATUS = new MonthListType('999979', '全期間(状態指定)');
  public static readonly INDASIN = new MonthListType('999989', '全期間(ASIN指定)');
  public static readonly INDMEMBER = new MonthListType('999999', '全期間(会員番号指定)');
  public static readonly ALL = new MonthListType('000000', '期間指定なし');
  public static readonly TODAY = new MonthListType('111111', '今日');

  // 全部
  public static values(): any {
    return [
      { value: this.NONE.value, text: i18n.t(this.NONE.text) },
      { value: this.INDSTATUS.value, text: i18n.t(this.INDSTATUS.text) },
      { value: this.INDASIN.value, text: i18n.t(this.INDASIN.text) },
      { value: this.INDMEMBER.value, text: i18n.t(this.INDMEMBER.text) },
      { value: this.MON202206.value, text: i18n.t(this.MON202206.text) },
      { value: this.MON202207.value, text: i18n.t(this.MON202207.text) },
      { value: this.MON202208.value, text: i18n.t(this.MON202208.text) },
      { value: this.MON202209.value, text: i18n.t(this.MON202209.text) },
      { value: this.MON202210.value, text: i18n.t(this.MON202210.text) },
      { value: this.MON202211.value, text: i18n.t(this.MON202211.text) },
      { value: this.MON202212.value, text: i18n.t(this.MON202212.text) },
    ];
  }

  // 全部(Invoice用)
  public static valuesForInvoice(): any {
    return [
      { value: this.TODAY.value, text: i18n.t(this.TODAY.text) },
      { value: this.NONE.value, text: i18n.t(this.NONE.text) },
      { value: this.MON202206.value, text: i18n.t(this.MON202206.text) },
      { value: this.MON202207.value, text: i18n.t(this.MON202207.text) },
      { value: this.MON202208.value, text: i18n.t(this.MON202208.text) },
      { value: this.MON202209.value, text: i18n.t(this.MON202209.text) },
      { value: this.MON202210.value, text: i18n.t(this.MON202210.text) },
      { value: this.MON202211.value, text: i18n.t(this.MON202211.text) },
      { value: this.MON202212.value, text: i18n.t(this.MON202212.text) },
      { value: this.ALL.value, text: i18n.t(this.ALL.text) },
    ];
  }

  private constructor(public readonly value: string, public readonly text: string) {}
  public getValue(): string { return this.value; }
  public getText(): string { return this.text; }
  public equals(other: MonthListType): boolean { return (this.text === other.text) ? true : false; }
  public toString(): string { return `${this.text}(${this.text})`; }
}
